import type { TabOption } from '@/components/chariot-ui';
import { CopyToClipboard } from '@/components/CopyToClipboard';
import type {
  MainTabKey,
  POEContent,
  SectionContent,
} from '@/sections/poe/types/poe.types';

export function processSshDataSource(
  poeData: POEContent,
  sections: Record<string, SectionContent>,
  tempTabs: Record<MainTabKey, TabOption[]>,
  mainTabKeys: MainTabKey[]
) {
  if (!poeData) return;
  // The SSH banner is the raw string in poeData
  const banner = typeof poeData === 'string' ? poeData : '';

  sections['ssh_banner'] = (
    <CopyToClipboard alwaysShowCopyIcon textToCopy={banner || ''}>
      <span className="text-chariot-text-primary cursor-pointer font-mono font-bold">
        {banner}
      </span>
    </CopyToClipboard>
  );

  if (mainTabKeys.includes('INFORMATION')) {
    tempTabs['INFORMATION'].push({
      label: 'Discovered Version',
      value: 'ssh_banner',
    });
  }
}
